import React, { useContext } from "react";

export type QueryContextType = {
    csrf: string;
};

export const QueryContext = React.createContext<QueryContextType | null>(null);

export const useQueryContext = (): QueryContextType => {
    const queryContext = useContext(QueryContext);
    if (queryContext === null) {
        throw new Error("No Query Context set!");
    }

    return queryContext;
};
